import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { clientJourney } from '@modules/client-journey/constants/URL'

// Único ponto do módulo que fala HTTP. Não é chamado enquanto
// `journey-source` estiver em 'mock' — existe já no formato final para que
// virar a chave não exija escrever código novo.
class APIClientJourney extends APITemplate {
  carregarTemplate() {
    return con.get(clientJourney.activeTemplate())
  }

  carregarResumos(clientIds) {
    return con.post(clientJourney.searchClients(), { clientIds })
  }

  carregar({ clientId } = {}) {
    if (!clientId) {
      return this.buildErrorResponse({
        message: 'Selecione um cliente para carregar a jornada.',
        status: 400,
      })
    }
    return con.get(clientJourney.clientJourney(clientId))
  }

  marcarPasso({ clientId, stepId, done = true, note } = {}) {
    if (!clientId || !stepId) {
      return this.buildErrorResponse({
        message: 'Selecione um passo para marcar.',
        status: 400,
      })
    }
    return con.post(clientJourney.markStep(clientId, stepId), { done, note })
  }

  carregarOverview({ clientId } = {}) {
    if (!clientId) {
      return this.buildErrorResponse({
        message: 'Selecione um cliente para carregar o resumo.',
        status: 400,
      })
    }
    return con.get(clientJourney.clientOverview(clientId))
  }

  carregarIndicadores() {
    return con.get(clientJourney.indicators())
  }
}

const apiClientJourney = new APIClientJourney()

export { apiClientJourney }
